import { customAlphabet } from 'nanoid'

export const ID_CHARS =
  '0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz'

const nanoid = customAlphabet(ID_CHARS)

export const defaultLength = 21
export const getId = () => nanoid(defaultLength)
export const isValidId = (id: string) => id.length === defaultLength

export const getIdForHTML = () => {
  // html IDs must start with a letter
  return customAlphabet('ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz')(
    defaultLength
  )
}

export const generateMCPId = () => {
  return customAlphabet(ID_CHARS)(64)
}

export { getIdempotentId } from './get-idempotent-id'
